import React, { useState } from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import AuthShell, { SubmitBtn } from "../../components/AuthShell";
import { useAuth } from "../../context/AuthContext";

const MfaVerify = () => {
  const { verifyMfaLogin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const mfaToken = location.state?.mfaToken;
  const dest = location.state?.dest || "/a/dashboard";
  const [code, setCode] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  if (!mfaToken) return <Navigate to="/login" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await verifyMfaLogin(mfaToken, code);
      navigate(dest, { replace: true });
    } catch (e) {
      setErr(e?.response?.data?.detail || "Invalid code");
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Two-factor authentication" subtitle="Enter the 6-digit code from your authenticator app">
      <form onSubmit={submit}>
        <div className="w-14 h-14 rounded-full bg-indigo-50 text-indigo-500 flex items-center justify-center mb-5"><ShieldCheck size={26} /></div>
        {err && <div className="mb-4 text-sm text-rose-600 bg-rose-50 border border-rose-100 rounded-lg px-3 py-2">{err}</div>}
        <input
          autoFocus inputMode="numeric" maxLength={6} value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
          placeholder="000000"
          className="w-full text-center tracking-[0.6em] text-2xl font-semibold px-3 py-3 rounded-lg border border-gray-200 outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-400 mb-4"
        />
        <SubmitBtn loading={loading} disabled={code.length !== 6}>Verify &amp; continue</SubmitBtn>
      </form>
    </AuthShell>
  );
};

export default MfaVerify;
